import { useTheme } from '@/context/ThemeContext';
import { useBlogPage } from './useBlogPage';

export function useBlogTheme() {
  const { theme } = useTheme();
  const { isSingleBlogPage } = useBlogPage();

  const isBlogLightTheme = isSingleBlogPage && theme === 'light' ? true : false;

  return { isBlogLightTheme };
}
